/**
 * A more mathematically sound modulo (%) which always gives a positive
 * remainder. This is useful when you have a list of items and want to "wrap
 * around" from the start to the end when encountering a negative index.
 *
 * More background: JavaScript confoundingly implements modulo differently from
 * other languages, and unexpectedly gives negative remainders. There is little
 * mathematical use for this behavior. By always giving a positive remainder,
 * most other languages create nice cyclic patterns even when encountering
 * negative divisors.
 *
 * |  `n`  |  `positiveMod(n, 3)` |  `n % 3` (JS) |
 * |------:|---------------------:|--------------:|
 * |  -5   |           1          |       -2      |
 * |  -4   |           2          |       -1      |
 * |  -3   |           0          |       -0      |
 * |  -2   |           1          |       -2      |
 * |  -1   |           2          |       -1      |
 * |   0   |           0          |        0      |
 * |   1   |           1          |        1      |
 * |   2   |           2          |        2      |
 */
export function positiveMod(num: number, modulus: number) {
  return ((num % modulus) + modulus) % modulus;
}
